/* import __COLOCATED_TEMPLATE__ from './fin-start-conversation-section.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();